<template>
    <div class="expanded_log_details">
        <div v-html="getTextHTMLEdited()"></div><br/>
    </div>
</template>
<script>
export default {
    props: {
        detailedLoggerObj : {
            type: Array,
            required: true
        }
    },
    data() {
        return {
        }
    },
    methods: {
        getTextHTMLEdited() {
            let text = this.detailedLoggerObj;
            if(text.value_before===undefined){text.value_before=' ';}
            if(text.value_after===undefined){text.value_after=' ';}

            let from_val_html_embeded = '<span class="action_changed_value">'+text.value_before+'</span>';
            let to_val_html_embeded = '<span class="action_changed_value">'+text.value_after+'</span>';
            let entity_html_embeded = '<span class="audit_changed_key">'+text.entity+'</span>';
            let msg_html = '';
            
            if(text.action === 'create') {
                if(text.value_after=='') { to_val_html_embeded = '' }
                msg_html = this.$t('audit.added_log_msg_str',{ entity: entity_html_embeded, value: to_val_html_embeded});
            }
            else {
                msg_html =  this.$t('audit.changed_log_msg_str', { entity: entity_html_embeded ,from: from_val_html_embeded, to: to_val_html_embeded });
            }
            return msg_html;
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/views/admin/audit-trail/components/LogDetailComponent.vue